module.exports = __webpack_public_path__ + "./Jasmine2_55944a0b37420a6465d70173a9957035.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2022/Jasmine2.png
// module id = 559
// module chunks = 0